<template>
    <div class="row h-100" @keydown="applyShortcut">
        <div id="project-nav-list" class="col-2">
            <div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
                <a class="nav-link active" id="project-props-general-tab" data-toggle="pill" href="#project-props-general"
                   role="tab" aria-selected="true">General</a>
                <a class="nav-link" id="project-props-chart-tab" data-toggle="pill" href="#project-props-chart"
                   role="tab" aria-selected="false" @click="updateGanttChart">Gantt Chart</a>
            </div>
        </div>
        <div class="col-10 tab-content h-100">
            <div class="tab-pane fade show active" id="project-props-general" role="tabpanel">
                <div class="form-group">
                    <label for="modal-project-name">Name</label>
                    <input type="text" class="form-control" id="modal-project-name" v-model="projectName">
                </div>
                <BtnSubmit title="Apply" spinner ref="submitButton" :submit-handler="updateProject">
                </BtnSubmit>
            </div>
            <div class="h-100 tab-pane fade" id="project-props-chart" role="tabpanel">
                <GanttChart ref="ganttChart"></GanttChart>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
  import {ProjectDto} from '../Teams';
  import {handleXhrError, ShortcutHandler} from '../utils/Ui';
  import {ProjectUpdate} from '../ProjectRoutes';
  import BtnSubmit from './BtnSubmit.vue';
  import GanttChart from './GanttChart.vue';
  import {DashboardSelectionListenerDestroy, getDashboardSelection} from '@/Dashboard';

  import $ from 'jquery';

  @Component({
    components: {BtnSubmit, GanttChart},
  })
  export default class ProjectPropertiesPane extends Vue {
    @Prop()
    public project!: ProjectDto;

    private projectName: string = "";

    private shortcutHandler = new ShortcutHandler();
    private listenerDestroyer: DashboardSelectionListenerDestroy = () => {};

    public $refs!: {
      ganttChart: GanttChart
    };

    public constructor() {
      super();
      this.shortcutHandler.register('Enter', () => this.updateProject());
    }

    public mounted() {
      let selection = getDashboardSelection();
      this.listenerDestroyer = selection.onSelectionChange(() => {
        if (selection.project) this.onProjectChange(selection.project)
      });
      if (this.project) {
        this.onProjectChange(this.project);
      }
    }

    public maxTabHeight(): number {
      let maxTabHeight = $("#project-nav-list").height();
      $(this.$el).find(".tab-pane").each((_, tab) => {
        maxTabHeight = Math.max(maxTabHeight, $(tab).height());
      });
      return maxTabHeight;
    }

    public updateProject(): JQueryPromise<any> {
      const filename = this.projectName;
      const project = this.project!;
      return ProjectUpdate.invoke({
        projectRefid: project.refid,
        filename,
      }).then(() => {
        project.name = filename;
      }).fail((jqXhr) => handleXhrError(jqXhr, 'can\'t update project name'));
    }

    public applyShortcut(e: KeyboardEvent) {
      this.shortcutHandler.handle(e);
    }

    @Watch('project')
    private onProjectChange(project: ProjectDto) {
      if (project) {
        this.projectName = project.name;
        if ($('#project-props-chart-tab').hasClass('active')) {
          this.updateGanttChart();
        }
      }
    }

    public updateGanttChart() {
      this.$refs.ganttChart.updateGraph(this.project.refid);
    }
  }
</script>

